import { Component, OnInit } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-leave-confirmation",
    templateUrl: "./leave-confirmation.component.html",
    styleUrls: ["./leave-confirmation.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class LeaveConfirmationComponent implements OnInit {
  constructor(public translate: TranslateService, private authService: AuthService) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}
}
